import appAxios from "services/axios";
class UsersService {
  me = async () => {
    return await appAxios.get("/user");
  };
  // Запоминаем выбранную организацию на сервере
  updateLastOrg = async (orgID: string) => {
    return await appAxios.put("/user/last-org", { orgID });
  };
}

export default new UsersService();
